﻿//Jquery
import "./jquery-global.js";
import $ from "jquery";

import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import GLightbox from 'glightbox';
import printThis from "print-this";
import flatpickr from "flatpickr";

//Bootstrap JS
import * as bootstrap from 'bootstrap';
import {hide} from "@popperjs/core";
import DateHolidays from 'date-holidays';
import {loaderShow} from "./loader";


let lgMaxWidth = window.matchMedia("(max-width: 992px)");
let mdMinWidth = window.matchMedia("(min-width: 768px)");


export function initiateComponents() {
    //jquery validator defaults
    $.validator.setDefaults({
        errorClass: "", validClass: "", highlight: function (element, errorClass, validClass) {
            $(element).addClass("is-invalid").removeClass("is-valid");
            if (element.id) {
                $(element.form).find("[data-valmsg-for=" + element.id + "]").addClass("invalid-feedback");
            }
        }, unhighlight: function (element, errorClass, validClass) {
            $(element).addClass("is-valid").removeClass("is-invalid");
            if (element.id) {
                $(element.form).find("[data-valmsg-for=" + element.id + "]").removeClass("invalid-feedback");
            }
        },
    });

    initiateQuantityInputs();
    initShowWhen();

    $("input.date-picker").each(function () {
        let self = $(this);

        let maxDate = new Date();
        if (self.data("max-date")) {
            let maxDateString = self.data("max-date");
            if (maxDateString === "today") {
                maxDate = new Date();
            } else if (maxDateString === "undefined" || maxDateString === "null") {
                maxDate = null;
            } else {
                maxDate = new Date().fp_incr(parseInt(maxDateString));
            }
        }

        let minDate = undefined;
        if (self.data("min-date")) {
            let minDateString = self.data("min-date");
            if (minDateString === "today") {
                minDate = new Date();
            } else if (minDateString === "undefined" || minDateString === "null") {
                minDate = null;
            } else {
                minDate = new Date().fp_incr(parseInt(minDateString));
            }
        }

        let disableDates = [];

        if (self.data("disable-holidays")) {

            disableDates.push(function (date) {
                return (date.getDay() === 0);
            });
            disableDates.push(function (date) {
                const today = new Date();
                // const isThursdayOrFriday = today.getDay() === 4 || today.getDay() === 5;
                const isFriday = today.getDay() === 5;

                if (isFriday) {
                    const nextSaturday = new Date(today);
                    nextSaturday.setDate(today.getDate() + (6 - today.getDay()));
                    // nextSaturday.setDate(6);

                    return date.getFullYear() === nextSaturday.getFullYear() &&
                        date.getMonth() === nextSaturday.getMonth() &&
                        date.getDate() === nextSaturday.getDate();
                }

                return false;
            });

            const hd = new DateHolidays('GB', 'eng');
            // Get holidays for the current year
            const currentYear = new Date().getFullYear();
            let yearHolidays = [{
                year: currentYear,
                holidays: hd.getHolidays(currentYear)
            }];

            let currentYearHolidays = yearHolidays[0];

            disableDates.push(function (date) {
                let currentDateYear = date.getFullYear();
                let currentDateMonth = date.getMonth();
                let currentDateDay = date.getDate();
                if (currentYearHolidays.year !== currentDateYear) {
                    if (yearHolidays.find(y => y.year === currentDateYear)) {
                        currentYearHolidays = yearHolidays.find(y => y.year === currentDateYear);
                    } else {
                        yearHolidays.push({
                            year: currentDateYear,
                            holidays: hd.getHolidays(currentDateYear)
                        });
                        currentYearHolidays = yearHolidays.find(y => y.year === currentDateYear);
                    }
                }

                return currentYearHolidays.holidays.filter(f => f.type === "public").find(holiday => (currentDateYear === holiday.start.getFullYear() &&
                    currentDateMonth === holiday.start.getMonth() &&
                    currentDateDay === holiday.start.getDate()));
            });

            let customStringDates = self.data("disable-holidays");
            if (customStringDates.length) {
                let customHolidays = [];
                customStringDates.split(',').forEach(function (item) {
                    let date = new Date(item);
                    customHolidays.push(date);
                });

                disableDates.push(function (date) {
                    return customHolidays.find(holiday => (date.getFullYear() === holiday.getFullYear() &&
                        date.getMonth() === holiday.getMonth() &&
                        date.getDate() === holiday.getDate()));
                });
            }
        }

        let defaultValue = self.attr('value');
        let options = {
            // altFormat: "j F, Y",
            dateFormat: "d/m/Y",
            defaultDate: defaultValue,
            maxDate: maxDate,
            minDate: minDate,
            disable: disableDates,
            locale: {
                "firstDayOfWeek": 1
            },
            onChange: function (selectedDates, dateStr, instance) {
                self.val(dateStr);
            },
            onReady: function (dateObj, dateStr, instance) {
                $('.flatpickr-calendar').each(function () {
                    let $this = $(this);
                    if ($this.find('.flatpickr-clear').length < 1) {
                        $this.append('<div class="flatpickr-clear btn btn-sm btn-primary my-2">Clear</div>');
                        $this.find('.flatpickr-clear').on('click', function () {
                            instance.clear();
                            instance.close();
                        });
                    }
                });
            }
        };

        self.flatpickr(options);

    });

    GLightbox({
        selector: ".product-gallery,.glightbox",
    });

    $('input[type="file"][data-handler][data-target]').each(function () {
        let fileInput = $(this);
        fileInput.on("change", function (e) {
            let fileName = e.target.files[0].name;
            $(fileInput.data("target")).html(fileName);
            $(fileInput.data("target")).append('<button type="button" class="btn-close p-2 mt-1" aria-label="Close"></button>');
            $(fileInput.data("target")).addClass("show");
            $(fileInput.data("target")).find('.btn-close').on("click", function (e) {
                e.preventDefault();
                fileInput[0].value = '';
                $(fileInput.data("target")).removeClass("show");
            });
        });
        $(fileInput.data("handler")).on("click", function () {
            fileInput.trigger("click");
        });
    });


    lgMaxWidthHandler(lgMaxWidth);
    lgMaxWidth.addListener(lgMaxWidthHandler);

    mdMinWidthHandler(mdMinWidth);
    mdMinWidth.addListener(mdMinWidthHandler);

    $("[data-copy]").each(function () {
        let self = $(this);
        let text = self.data('copy');
        let result = null;
        self.on("click", function () {
            if (!navigator.clipboard) {
                result = fallbackCopyTextToClipboard(text);
            } else {
                navigator.clipboard.writeText(text).then(function () {
                    result = true;
                }, function (err) {
                    result = false
                });
            }

            setTimeout(function () {
                if (result) {
                    let thisLabel = self.text();
                    if (!thisLabel) {
                        thisLabel = "Copied";
                    }
                    self.text(self.data("copied"));
                    setTimeout(function () {
                        self.text(thisLabel);
                    }, 2000);
                }
            }, 100);

        });
    });

    $("[data-print]").each(function () {
        let self = $(this);
        let container = self.data('print');
        self.on("click", function () {
            $(container).printThis();
        });
    });

    $(".clear-container").each(function () {
        let self = $(this);
        let input = self.children("input");
        let button = self.children("[clear-button]");

        input[0].addEventListener("input", function () {
            if (input.val().length > 0) {
                button.show();
            } else {
                button.hide();
            }
        });

        input.on("focusin", function () {
            if (input.val().length > 0) {
                button.show();
            } else {
                button.hide();
            }
        });

        input.on("focusout", function () {
            button.hide();
        });

        button.on("mousedown", function (e) {
            e.preventDefault();
            button.hide();
            input.val('');
            input.trigger('input');
            input.focus();
        });
    });

    $('[data-click-target]').each(function () {
        let self = $(this);
        let target = self.data('click-target');
        self.on("click", function () {
            document.querySelector(target).click();
        });
    });

    let tooltips = $('[data-bs-toggle="tooltip"]');
    tooltips.each(function () {
        let tooltip = new bootstrap.Tooltip(this, {
            boundary: document.body
        });
    });


    const forms = document.querySelectorAll('form[submit-on-change]');
    forms.forEach(form => {
        const inputs = form.querySelectorAll('select, input, textarea');
        inputs.forEach(input => {
            input.addEventListener('change', () => {
                if (form.checkValidity()) {
                    loaderShow('body');
                    form.submit();
                }
            });
        });
    });
}

export function initiateQuantityInputs() {
    $("input[data-spinner]").each(function () {
        let self = $(this);
        let minusElement = self.parent().find('.btn-minus')[0];
        let plusElement = self.parent().find('.btn-plus')[0];
        let selfElement = self[0];

        let step = parseInt(self.attr('step') ?? 1);
        let max = parseInt(self.attr('max') ?? 999999);
        let min = parseInt(self.attr('min') ?? 1);

        selfElement.oninput = function () {
            this.value = this.value.replace(/[^0-9]/g, '');
            this.size = (this.value.length ? this.value.length : 1)
        };

        selfElement.onchange = function () {
            this.value = this.value > max ? max : this.value < min ? min : this.value;
        };

        plusElement.addEventListener("click", () => {
            if (parseInt(selfElement.value) + step >= max) {
                selfElement.value = max;
                return;
            }
            selfElement.value = parseInt(selfElement.value) + step;
        }, false);


        minusElement.addEventListener("click", () => {
            if ((parseInt(selfElement.value) - step) <= min) {
                selfElement.value = min;
                return;
            }

            selfElement.value = parseInt(selfElement.value) - step;
        }, false);
    });

    $("input.quantity-input").on("input, change, keyup", function () {
        let max = $(this).attr("max");
        if (max && max.length > 0) {
            let value = parseInt($(this).val());

            if (value > max) {
                $(this).val(max);
                $(this).attr("size", max.toString().length);
            }
        }
    });
}

export function initShowWhen() {
    const toggleableElements = document.querySelectorAll('[data-show-when]');

    toggleableElements.forEach(function (element) {
        // Which input name/id do we watch?
        const inputName = element.getAttribute('data-show-when');
        // Which value triggers showing this element?
        const requiredValue = element.getAttribute('data-show-when-value');

        // Find the matching input/selector by name (could also match by ID if you prefer)
        const inputElement = document.querySelector('[name="' + inputName + '"]');
        if (!inputElement) return; // If no matching input found, skip

        // Toggle function for initial load + subsequent changes
        function updateVisibility() {
            if (inputElement.value === requiredValue) {
                element.classList.remove('d-none');
            } else {
                element.classList.add('d-none');
                
                // Reset all inputs/selects/textareas inside this element
                const childElements = element.querySelectorAll('input, select, textarea');
                childElements.forEach(child => {
                    if (child.type === 'checkbox' || child.type === 'radio') {
                        child.checked = false;
                    } else {
                        child.value = '';
                    }
                    child.dispatchEvent(new Event('change', { bubbles: true }));
                });
            }
        }

        // Run once on page load
        updateVisibility();
        // Update on user input change
        inputElement.addEventListener('change', updateVisibility);
    });
}

function fallbackCopyTextToClipboard(text) {
    let textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    let result = false;
    try {
        result = document.execCommand('copy')
    } catch (err) {
        result = false;
    }

    document.body.removeChild(textArea);
    return result;
}

function lgMaxWidthHandler(e) {
    if (e.matches) {
        data_move();
    } else {
        data_move(true);
    }
}

function data_move(moveBack = false) {
    if (moveBack) {
        $('[data-move]').each(function () {
            let self = $(this);
            let source = self.data('source');
            self.appendTo(source);
        });
    } else {
        $('[data-move]').each(function () {
            let self = $(this);
            let target = self.data('move');
            self.appendTo(target);
        });
    }
}

function mdMinWidthHandler(e) {
    let convertableTabs = $(".convertable-tab");
    if (e.matches) {
        //Sync Tabs show class
        convertableTabs.each(function () {
            let convertableTab = $(this);
            convertableTab.find('.nav-link[data-bs-toggle="tab"][data-bs-target]').each(function () {
                let tab = $(this);
                if (tab.hasClass('active')) {
                    $(tab.attr("data-bs-target")).addClass('show active');
                } else {
                    $(tab.attr("data-bs-target")).removeClass('show active');
                }
            });
        });

        //Auto Collapse Items into show more
        $('[data-collapse-holder]').each(function () {
            let self = $(this);
            if (self.children().length > 0) {
                self.children().insertBefore(self);
            }
        });
    } else {
        //Sync Collapse show class
        convertableTabs.each(function () {
            let convertableTab = $(this);
            convertableTab.find('[data-bs-toggle="collapse"][href]').each(function () {
                let collapse = $(this);
                if (collapse.attr('aria-expanded') == "true") {
                    $(collapse.attr("href")).addClass("show");
                    $(collapse.attr("href")).removeClass("active");
                } else {
                    $(collapse.attr("href")).removeClass("show active");
                }
            })
        });

        //Auto Collapse Items into show more
        $('[data-collapse-holder]').each(function () {
            let self = $(this);
            let parent = self.parent();
            if (parent.find(self.data("collapse-holder")).length > parseInt(self.data("collapse-size")) + 1) {
                parent.find(self.data("collapse-holder") + ":gt(" + self.data("collapse-size") + ")").appendTo(self);
                parent.find('[data-collapse-link]').removeClass('d-none');
            }
        });
    }
}